"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPanelFromPanelNameKEY = exports.getPanelIDFromPanelNameKey = exports.getPanelEncodedKeyFromPanelNameKey = exports.esPanelKeyToPaneNameKey = exports.esPanelKeyToDatastoreEncodedKey = exports.getTaxiConvEsKey = exports.getTaxiEsKey = exports.getVanAccessEsKey = exports.getAccessEsKey = exports.getGreenEsKey = exports.getMotoEsKey = exports.getVanEsKey = exports.getBerlineBusinessEsKey = exports.getVaoEsKey = exports.getBerlineEsKey = exports.getTaxiConvEncodedKey = exports.isTaxiConv = exports.getTaxiEncodedKey = exports.isTaxi = exports.getVanAccessEncodedKey = exports.isVanAccess = exports.getAccessEncodedKey = exports.isAccess = exports.getGreenEncodedKey = exports.isGreen = exports.getMotoEncodedKey = exports.isMoto = exports.getVanEncodedKey = exports.isVan = exports.getBerlineBusinessEncodedKey = exports.isVao = exports.isBerlineBusiness = exports.getVaoEncodedKey = exports.getBerlineEncodedKey = exports.isCoVtc = exports.isBerline = exports.getPanelNameEncodedKey = exports.getPanelNameKey = exports.getPanelNameLabel = exports.getPanelNameDescription = exports.getPanelNameLabelByKey = exports.getPanelNameDescriptionByKey = void 0;
var allocab_commons_shared_types_1 = require("@allocab/allocab-commons-shared-types");
var utils_1 = require("./utils");
var getPanelNameDescriptionByKey = function (key, locale, sharable) {
    var encodedKey = (0, exports.getPanelNameEncodedKey)(key);
    return (0, exports.getPanelNameDescription)(encodedKey, locale, sharable);
};
exports.getPanelNameDescriptionByKey = getPanelNameDescriptionByKey;
var getPanelNameLabelByKey = function (key, locale, sharable) {
    if (key === 'COVTC') {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.COVTC;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.COVTC;
        }
    }
    var encodedKey = (0, exports.getPanelNameEncodedKey)(key);
    return (0, exports.getPanelNameLabel)(encodedKey, locale, sharable);
};
exports.getPanelNameLabelByKey = getPanelNameLabelByKey;
var getPanelNameDescription = function (panelEncodedKey, locale, sharable) {
    if (!locale || (locale != 'fr' && locale != 'en')) {
        locale = 'fr';
    }
    if ((0, exports.isBerline)(panelEncodedKey)) {
        if (sharable) {
            if (locale == 'fr') {
                return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.COVTC;
            }
            else {
                return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.COVTC;
            }
        }
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.BERLINE;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.BERLINE;
        }
    }
    if ((0, exports.isBerlineBusiness)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.BUSINESS;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.BUSINESS;
        }
    }
    if ((0, exports.isVao)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.VAO;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.VAO;
        }
    }
    if ((0, exports.isVan)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.VAN;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.VAN;
        }
    }
    if ((0, exports.isMoto)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.MOTO;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.MOTO;
        }
    }
    if ((0, exports.isGreen)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.GREEN;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.GREEN;
        }
    }
    if ((0, exports.isTaxi)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.TAXI;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.TAXI;
        }
    }
    if ((0, exports.isTaxiConv)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.TAXI_CONV;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.TAXI_CONV;
        }
    }
    if ((0, exports.isAccess)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.ACCESS;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.ACCESS;
        }
    }
    if ((0, exports.isVanAccess)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.VAN_ACCESS;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.VAN_ACCESS;
        }
    }
    if (sharable) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.COVTC;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_EN.COVTC;
        }
    }
    return allocab_commons_shared_types_1.PANEL_NAME_DESCRIPTION_FR.UNKNOWN;
};
exports.getPanelNameDescription = getPanelNameDescription;
var getPanelNameLabel = function (panelEncodedKey, locale, sharable) {
    if (!locale || (locale != 'fr' && locale != 'en')) {
        locale = 'fr';
    }
    if ((0, exports.isBerline)(panelEncodedKey)) {
        if (sharable) {
            if (locale == 'fr') {
                return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.COVTC;
            }
            else {
                return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.COVTC;
            }
        }
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.BERLINE;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.BERLINE;
        }
    }
    if ((0, exports.isBerlineBusiness)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.BUSINESS;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.BUSINESS;
        }
    }
    if ((0, exports.isVao)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.VAO;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.VAO;
        }
    }
    if ((0, exports.isVan)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.VAN;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.VAN;
        }
    }
    if ((0, exports.isMoto)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.MOTO;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.MOTO;
        }
    }
    if ((0, exports.isGreen)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.GREEN;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.GREEN;
        }
    }
    if ((0, exports.isTaxi)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.TAXI;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.TAXI;
        }
    }
    if ((0, exports.isTaxiConv)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.TAXI_CONV;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.TAXI_CONV;
        }
    }
    if ((0, exports.isAccess)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.ACCESS;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.ACCESS;
        }
    }
    if ((0, exports.isVanAccess)(panelEncodedKey)) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.VAN_ACCESS;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.VAN_ACCESS;
        }
    }
    if (sharable) {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.COVTC;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.COVTC;
        }
    }
    return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.UNKNOWN;
};
exports.getPanelNameLabel = getPanelNameLabel;
var getPanelNameKey = function (panelEncodedKey, sharable) {
    if ((0, exports.isBerline)(panelEncodedKey)) {
        if (sharable) {
            return 'COVTC';
        }
        return 'BERLINE';
    }
    if ((0, exports.isBerlineBusiness)(panelEncodedKey)) {
        return 'BUSINESS';
    }
    if ((0, exports.isVao)(panelEncodedKey)) {
        return 'VAO';
    }
    if ((0, exports.isVan)(panelEncodedKey)) {
        return 'VAN';
    }
    if ((0, exports.isMoto)(panelEncodedKey)) {
        return 'MOTO';
    }
    if ((0, exports.isGreen)(panelEncodedKey)) {
        return 'GREEN';
    }
    if ((0, exports.isTaxi)(panelEncodedKey)) {
        return 'TAXI';
    }
    if ((0, exports.isTaxiConv)(panelEncodedKey)) {
        return 'TAXI_CONV';
    }
    if ((0, exports.isAccess)(panelEncodedKey)) {
        return 'ACCESS';
    }
    if ((0, exports.isVanAccess)(panelEncodedKey)) {
        return 'VAN_ACCESS';
    }
    if ((0, exports.isCoVtc)(panelEncodedKey)) {
        return 'COVTC';
    }
    return 'UNKNOWN';
};
exports.getPanelNameKey = getPanelNameKey;
var getPanelNameEncodedKey = function (panelKey) {
    if (panelKey === 'BERLINE') {
        return (0, exports.getBerlineEncodedKey)();
    }
    if (panelKey === 'BUSINESS') {
        return (0, exports.getBerlineBusinessEncodedKey)();
    }
    if (panelKey === 'VAN') {
        return (0, exports.getVanEncodedKey)();
    }
    if (panelKey === 'MOTO') {
        return (0, exports.getMotoEncodedKey)();
    }
    if (panelKey === 'GREEN') {
        return (0, exports.getGreenEncodedKey)();
    }
    if (panelKey === 'VAO') {
        return (0, exports.getVaoEncodedKey)();
    }
    if (panelKey === 'TAXI') {
        return (0, exports.getTaxiEncodedKey)();
    }
    if (panelKey === 'TAXI_CONV') {
        return (0, exports.getTaxiConvEncodedKey)();
    }
    if (panelKey === 'ACCESS') {
        return (0, exports.getAccessEncodedKey)();
    }
    if (panelKey === 'VAN_ACCESS') {
        return (0, exports.getVanAccessEncodedKey)();
    }
    if (panelKey === 'COVTC') {
        var berine = (0, exports.getBerlineEncodedKey)();
        return berine + '_shared';
    }
    return 'UNKNOWN';
};
exports.getPanelNameEncodedKey = getPanelNameEncodedKey;
var isBerline = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGJ7olLcBDA' === encodedKey || 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUY-ZbBGww' === encodedKey) {
        return true;
    }
    return false;
};
exports.isBerline = isBerline;
var isCoVtc = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGJ7olLcBDA_shared' === encodedKey ||
        'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUY-ZbBGww_shared' === encodedKey) {
        return true;
    }
    return false;
};
exports.isCoVtc = isCoVtc;
var getBerlineEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGJ7olLcBDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUY-ZbBGww';
    }
};
exports.getBerlineEncodedKey = getBerlineEncodedKey;
var getVaoEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICAtZfV3LMIDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIC43JSIkAkM';
    }
};
exports.getVaoEncodedKey = getVaoEncodedKey;
var isBerlineBusiness = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGLTigLQBDA' === encodedKey || 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYydqDHAw' === encodedKey) {
        return true;
    }
    return false;
};
exports.isBerlineBusiness = isBerlineBusiness;
var isVao = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICAtZfV3LMIDA' === encodedKey ||
        'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIC43JSIkAkM' === encodedKey) {
        return true;
    }
    return false;
};
exports.isVao = isVao;
var getBerlineBusinessEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGLTigLQBDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYydqDHAw';
    }
};
exports.getBerlineBusinessEncodedKey = getBerlineBusinessEncodedKey;
var isVan = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGJ6l_bQBDA' === encodedKey || 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYjPjXHAw' === encodedKey) {
        return true;
    }
    return false;
};
exports.isVan = isVan;
var getVanEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGJ6l_bQBDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYjPjXHAw';
    }
};
exports.getVanEncodedKey = getVanEncodedKey;
var isMoto = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGMSB87UBDA' === encodedKey || 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYjqSHHww' === encodedKey) {
        return true;
    }
    return false;
};
exports.isMoto = isMoto;
var getMotoEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGMSB87UBDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYjqSHHww';
    }
};
exports.getMotoEncodedKey = getMotoEncodedKey;
var isGreen = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA_oazqbUKDA' === encodedKey ||
        'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgICowZmTmQoM' === encodedKey) {
        return true;
    }
    return false;
};
exports.isGreen = isGreen;
var getGreenEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA_oazqbUKDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgICowZmTmQoM';
    }
};
exports.getGreenEncodedKey = getGreenEncodedKey;
var isAccess = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA4a6So7gKDA' === encodedKey ||
        'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDo7NeyjQoM' === encodedKey) {
        return true;
    }
    return false;
};
exports.isAccess = isAccess;
var getAccessEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA4a6So7gKDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDo7NeyjQoM';
    }
};
exports.getAccessEncodedKey = getAccessEncodedKey;
var isVanAccess = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA4eul8KYKDA' === encodedKey ||
        'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDomsvDngoM' === encodedKey) {
        return true;
    }
    return false;
};
exports.isVanAccess = isVanAccess;
var getVanAccessEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA4eul8KYKDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDomsvDngoM';
    }
};
exports.getVanAccessEncodedKey = getVanAccessEncodedKey;
var isTaxi = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA9qW8_aMLDA' === encodedKey ||
        'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDIjKzvlAoM' === encodedKey) {
        return true;
    }
    return false;
};
exports.isTaxi = isTaxi;
var getTaxiEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA9qW8_aMLDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDIjKzvlAoM';
    }
};
exports.getTaxiEncodedKey = getTaxiEncodedKey;
var isTaxiConv = function (encodedKey) {
    if ((0, utils_1.isEmpty)(encodedKey)) {
        return false;
    }
    if ('ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICAgaKDw7cKDA' === encodedKey ||
        'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgICo1a_hgwoM' === encodedKey) {
        return true;
    }
    return false;
};
exports.isTaxiConv = isTaxiConv;
var getTaxiConvEncodedKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICAgaKDw7cKDA';
    }
    else {
        return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgICo1a_hgwoM';
    }
};
exports.getTaxiConvEncodedKey = getTaxiConvEncodedKey;
var getBerlineEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_384119838';
    }
    else {
        return 'PanelName_57691001';
    }
};
exports.getBerlineEsKey = getBerlineEsKey;
var getVaoEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_4731083961483264';
    }
    else {
        return 'PanelName_5137198765441024';
    }
};
exports.getVaoEsKey = getVaoEsKey;
var getBerlineBusinessEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_377499956';
    }
    else {
        return 'PanelName_58781001';
    }
};
exports.getBerlineBusinessEsKey = getBerlineBusinessEsKey;
var getVanEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_379540126';
    }
    else {
        return 'PanelName_60161036';
    }
};
exports.getVanEsKey = getVanEsKey;
var getMotoEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_381468868';
    }
    else {
        return 'PanelName_65131022';
    }
};
exports.getMotoEsKey = getMotoEsKey;
var getGreenEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_5864018453430272';
    }
    else {
        return 'PanelName_5740110379876352';
    }
};
exports.getGreenEsKey = getGreenEsKey;
var getAccessEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_5876997659574272';
    }
    else {
        return 'PanelName_5688415707856896';
    }
};
exports.getAccessEsKey = getAccessEsKey;
var getVanAccessEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_5800483750428672';
    }
    else {
        return 'PanelName_5763763220905984';
    }
};
exports.getVanAccessEsKey = getVanAccessEsKey;
var getTaxiEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_6350692268474368';
    }
    else {
        return 'PanelName_5721286232899584';
    }
};
exports.getTaxiEsKey = getTaxiEsKey;
var getTaxiConvEsKey = function () {
    if (process.env.NODE_ENV === 'production') {
        return 'PanelName_5873695071420416';
    }
    else {
        return 'PanelName_5646039363747840';
    }
};
exports.getTaxiConvEsKey = getTaxiConvEsKey;
var esPanelKeyToDatastoreEncodedKey = function (esPanelKey) {
    if (esPanelKey === 'PanelName_57691001' || esPanelKey === 'PanelName_384119838') {
        return (0, exports.getBerlineEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_58781001' || esPanelKey === 'PanelName_377499956') {
        return (0, exports.getBerlineBusinessEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_60161036' || esPanelKey === 'PanelName_379540126') {
        return (0, exports.getVanEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_65131022' || esPanelKey === 'PanelName_381468868') {
        return (0, exports.getMotoEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_5740110379876352' || esPanelKey === 'PanelName_5864018453430272') {
        return (0, exports.getGreenEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_5688415707856896' || esPanelKey === 'PanelName_5876997659574272') {
        return (0, exports.getAccessEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_5763763220905984' || esPanelKey === 'PanelName_5800483750428672') {
        return (0, exports.getVanAccessEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_5721286232899584' || esPanelKey === 'PanelName_6350692268474368') {
        return (0, exports.getTaxiEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_5646039363747840' || esPanelKey === 'PanelName_5873695071420416') {
        return (0, exports.getTaxiConvEncodedKey)();
    }
    else if (esPanelKey === 'PanelName_5137198765441024' || esPanelKey === 'PanelName_5137198765441024') {
        return (0, exports.getVaoEncodedKey)();
    }
    return '';
};
exports.esPanelKeyToDatastoreEncodedKey = esPanelKeyToDatastoreEncodedKey;
var esPanelKeyToPaneNameKey = function (esPanelKey) {
    var encodedKey = (0, exports.esPanelKeyToDatastoreEncodedKey)(esPanelKey);
    if (encodedKey === '') {
        return 'UNKNOWN';
    }
    return (0, exports.getPanelNameKey)(encodedKey, false);
};
exports.esPanelKeyToPaneNameKey = esPanelKeyToPaneNameKey;
var getPanelEncodedKeyFromPanelNameKey = function (panelNameKey) {
    if (panelNameKey === 'BERLINE') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGJ7olLcBDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUY-ZbBGww';
        }
    }
    if (panelNameKey === 'BUSINESS') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGLTigLQBDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYydqDHAw';
        }
    }
    if (panelNameKey === 'VAN') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGJ6l_bQBDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYjPjXHAw';
        }
    }
    if (panelNameKey === 'MOTO') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHITCxIJUGFuZWxOYW1lGMSB87UBDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chILEglQYW5lbE5hbWUYjqSHHww';
        }
    }
    if (panelNameKey === 'GREEN') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA_oazqbUKDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgICowZmTmQoM';
        }
    }
    if (panelNameKey === 'ACCESS') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA4a6So7gKDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDo7NeyjQoM';
        }
    }
    if (panelNameKey === 'TAXI') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA9qW8_aMLDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDIjKzvlAoM';
        }
    }
    if (panelNameKey === 'TAXI_CONV') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICAgaKDw7cKDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgICo1a_hgwoM';
        }
    }
    if (panelNameKey === 'VAN_ACCESS') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICA4eul8KYKDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIDomsvDngoM';
        }
    }
    if (panelNameKey === 'VAO') {
        if (process.env.NODE_ENV === 'production') {
            return 'ag5zfmFsbG9jYWItcHJvZHIWCxIJUGFuZWxOYW1lGICAtZfV3LMIDA';
        }
        else {
            return 'ag1zfmFsbG9jYWItZGV2chYLEglQYW5lbE5hbWUYgIC43JSIkAkM';
        }
    }
    return '';
};
exports.getPanelEncodedKeyFromPanelNameKey = getPanelEncodedKeyFromPanelNameKey;
var getPanelIDFromPanelNameKey = function (panelNameKey) {
    if (panelNameKey === 'BERLINE') {
        if (process.env.NODE_ENV === 'production') {
            return '384119838';
        }
        else {
            return '57691001';
        }
    }
    if (panelNameKey === 'BUSINESS') {
        if (process.env.NODE_ENV === 'production') {
            return '377499956';
        }
        else {
            return '58781001';
        }
    }
    if (panelNameKey === 'VAN') {
        if (process.env.NODE_ENV === 'production') {
            return '379540126';
        }
        else {
            return '60161036';
        }
    }
    if (panelNameKey === 'MOTO') {
        if (process.env.NODE_ENV === 'production') {
            return '381468868';
        }
        else {
            return '65131022';
        }
    }
    if (panelNameKey === 'GREEN') {
        if (process.env.NODE_ENV === 'production') {
            return '5864018453430272';
        }
        else {
            return '5740110379876352';
        }
    }
    if (panelNameKey === 'VAO') {
        if (process.env.NODE_ENV === 'production') {
            return '4731083961483264';
        }
        else {
            return '5137198765441024';
        }
    }
    if (panelNameKey === 'ACCESS') {
        if (process.env.NODE_ENV === 'production') {
            return '5876997659574272';
        }
        else {
            return '5688415707856896';
        }
    }
    if (panelNameKey === 'TAXI') {
        if (process.env.NODE_ENV === 'production') {
            return '6350692268474368';
        }
        else {
            return '5721286232899584';
        }
    }
    if (panelNameKey === 'TAXI_CONV') {
        if (process.env.NODE_ENV === 'production') {
            return '5873695071420416';
        }
        else {
            return '5646039363747840';
        }
    }
    if (panelNameKey === 'VAN_ACCESS') {
        if (process.env.NODE_ENV === 'production') {
            return '5800483750428672';
        }
        else {
            return '5763763220905984';
        }
    }
    return '';
};
exports.getPanelIDFromPanelNameKey = getPanelIDFromPanelNameKey;
var getPanelFromPanelNameKEY = function (panelNameKey, locale, sharable) {
    if (!locale || (locale != 'fr' && locale != 'en')) {
        locale = 'fr';
    }
    if (panelNameKey === 'BERLINE') {
        if (sharable) {
            if (locale == 'fr') {
                return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.COVTC;
            }
            else {
                return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.COVTC;
            }
        }
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.BERLINE;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.BERLINE;
        }
    }
    if (panelNameKey === 'BUSINESS') {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.BUSINESS;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.BUSINESS;
        }
    }
    if (panelNameKey === 'VAN') {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.VAN;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.VAN;
        }
    }
    if (panelNameKey === 'MOTO') {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.MOTO;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.MOTO;
        }
    }
    if (panelNameKey === 'AMBULANCE') {
        if (locale == 'fr') {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.AMBULANCE;
        }
        else {
            return allocab_commons_shared_types_1.PANEL_NAME_LABEL_EN.AMBULANCE;
        }
    }
    return allocab_commons_shared_types_1.PANEL_NAME_LABEL_FR.UNKNOWN;
};
exports.getPanelFromPanelNameKEY = getPanelFromPanelNameKEY;
